import PropTypes from 'prop-types';
import { getProxyUrl } from '../../../utils/image';
import { getPlayerUrlById, getTeamUrl } from '../../../utils/routes';

function StatsLeadersRow({ data, type }) {
  const isTeam = type.includes('team');
  const { topListNumber } = data;

  const getRowText = () => {
    if (isTeam) {
      return data?.displayName;
    }

    if (!data?.displayName) {
      return `${data.givenName} ${data.surName}`;
    }

    return data?.displayName;
  };

  const getTeamLogo = () => {
    if (isTeam) {
      return data?.logoImage
        ? getProxyUrl(data?.logoImage, 50, 50)
        : '/wp-content/themes/sef-leagues/images/generic-team.png';
    }

    return (
      data?.teamLogo || '/wp-content/themes/sef-leagues/images/generic-team.png'
    );
  };

  const getClassName = () => {
    return topListNumber === 1
      ? 'stats-table__row px-lg-2 bg-comp-pink'
      : 'stats-table__row px-lg-2';
  };

  const url = isTeam ? getTeamUrl(data.abbrv) : getPlayerUrlById(data?.fogisId);

  return (
    <div className={getClassName()}>
      <div className="stats-table__number">{data.topListNumber}</div>
      <a
        style={{ pointerEvents: url ? 'auto' : 'none' }}
        href={url || ''}
        className="stats-table__player text-decoration-none"
      >
        <p className="name-with-team-logo text-color-primary-white m-0">
          <img className="ms-lg-2" src={getTeamLogo()} alt="team" />
          {getRowText()}
        </p>
      </a>
      <div className="stats-table__played" />
      <div className="stats-table__value text-color-primary-white stats-font-larger m-0">
        {data.stat}
      </div>
    </div>
  );
}

StatsLeadersRow.propTypes = {
  data: PropTypes.shape({
    stat: PropTypes.number,
    topListNumber: PropTypes.number,
  }).isRequired,
};

export default StatsLeadersRow;
